import styledComponent from "styled-components";
import { styled } from "@mui/material/styles";
import { Button, Select } from "@mui/material";
import {
  antiFlashWhite,
  black,
  brightGray,
  mainFont,
  trueBlue,
  white,
} from "../../utils/StyleHelpers";

export const LayoutWrapper = styledComponent.div`
  align-content: center;
`;

export const ContextContainer = styledComponent.div`
  width: 100%;
  margin-top: 1.52rem;
  padding: 0.25rem;
  justify-content: center;
  align-items: center;
  gap: 2.5rem;
`;

export const MovieWrapper = styledComponent.div`
  display: flex;
  margin-top: 1.5rem;
  width: 100%;
  height: 775px;
  flex-shrink: 0;
`;

export const BoxContainer = styledComponent.div`
  display: flex;
  width: auto;
  height: 51.6875rem;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  border: 1px solid ${black};
  background: ${white};
  margin-left: 1.5rem;
`;

export const TagContainer = styledComponent.div`
  display: flex;
  padding: 0.5625rem 20.6875rem 0.5625rem 1rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 0.5rem;
  border: 1px solid #cecece;
  background: ${antiFlashWhite};
  height: 3.1875rem;
`;

export const TagLabel = styledComponent.div`
  color: ${black};
  font-family: ${mainFont};
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledLabel = styledComponent.text`
  color: ${black};
  font-family: ${mainFont};
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledSubText = styledComponent.text`
  font-family: Inter;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.21rem;
`;

export const StyledSubLabel = styledComponent.div`
  width: 69.1875rem;
  overflow: hidden;
  color: ${black};
  text-overflow: ellipsis;
  font-family: ${mainFont};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledTextFieldItem = styledComponent.div`
  display: flex;
  height: 3rem;
  gap: 0.625rem;
  flex: 1 0 0;
  margin-top: 0.75rem;
`;

export const StyledButtonItem = styledComponent.div`
  display: flex;
  align-items: flex-start;
  height: 3rem;
  gap: 0.625rem;
  flex: 1 0 0;
  margin-top: 0.75rem;
`;

//* MUI STYLES *//
export const StyledMUISelect = styled(Select)({
  "& fieldset": {
    borderRadius: "0.5rem",
    border: `2px solid ${black}`,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "1.875rem",
    alignSelf: "stretch",
    textOverflow: "ellipsis",
    fontFamily: `${mainFont}`,
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "normal",
  },
  "&:hover": {
    "&& fieldset": {
      borderColor: `${trueBlue}`,
    },
  },
  "&:focus": {
    "&& fieldset": {
      borderColor: `${trueBlue}`,
    },
  },
});

export const StyledMUIButton = styled(Button)({
  display: "flex",
  padding: "1rem",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.625rem",
  flex: "1 0 0",
  borderRadius: "0.5rem",
  background: `${trueBlue}`,
  color: `${white}`,
  "&:disabled": {
    background: `${trueBlue}`,
    opacity: "0.5rem",
  },
});

export const StyledMUIButtonIcon = styled(Button)({
  display: "flex",
  padding: "1rem",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.625rem",
  borderRadius: "0.5rem",
  background: `${brightGray}`,
  "&:hover": {
    background: `${brightGray}`,
  },
  "&:disabled": {
    background: `${brightGray}`,
    opacity: "0.5rem",
  },
});
